export enum FeatureToggle {
  cashflow = 'rt_cashflow',
  cashflowCheckoutDiscrepancyAudits = 'rt_cashflow_checkout_discrepancy_audits',
  cashflowCheckoutDiscrepancyAuditsQAQueue = 'rt_cashflow_checkout_discrepancy_audits_qa_queue',
  cashflowCheckoutDiscrepancyOcr = 'rt_cashflow_checkout_discrepancy_ocr',
}
